/** Replaces `name` and `description` only. `description` travels as `null` when cleared, never as
 * `''` — the server normalizes an empty string to `null` the same way. */
class UpdateDocumentTemplate {
	constructor(
		public readonly organizationId: number,
		public readonly templateId: number,
		public readonly name: string,
		public readonly description: string | null,
	) {
		Object.freeze(this);
	}

	// `organizationId` and `templateId` are route identifiers: neither is echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			name: this.name,
			description: this.description,
		};
	}
}

export default UpdateDocumentTemplate;
